export default "__VITE_ASSET__BccDEF1H__"